import { HttpError } from "../../types/HttpError.js";
const abortableFetcher = async (url, initialRequestInit, timeout = 5e3, abortController = void 0) => {
  let requestInit = initialRequestInit;
  let timeoutPromise = new Promise(
    (_, reject) => setTimeout(() => {
      reject(new Error(`Request timed out after ${timeout} ms`));
    }, timeout)
  );
  if (abortController) {
    const { signal } = abortController;
    timeoutPromise = new Promise(
      (_, reject) => setTimeout(() => {
        abortController.abort();
        reject(new Error(`Request timed out after ${timeout} ms`));
      }, timeout)
    );
    requestInit = {
      ...initialRequestInit,
      signal
    };
  }
  try {
    const response = await Promise.race([
      fetch(url, requestInit),
      timeoutPromise
    ]);
    if (!response.ok) {
      throw new HttpError(
        response.status,
        response.statusText,
        `Network error: ${response.status} ${response.statusText}`
      );
    }
    return await response.json();
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new Error(`Request aborted: ${error.message}`);
    }
    throw error;
  }
};
export {
  abortableFetcher
};
